import { findBy$IdInTreeList, visitTreeList } from "../utils/tree";
import { TodoType } from '../models/todo-type';

export const getPriorityTaskList = (todos) => {
    const ret = [];
    visitTreeList(
        todos,
        todo => ret.push(todo),
        todo => {
            if (todo.parent) {
                const parent = findBy$IdInTreeList(todos, todo.parent.$ref);
                return [todo.type === TodoType.task && (!todo.parent || parent.type === TodoType.project),false];
            } else {
                return [todo.type === TodoType.task,false];
            }
        },
        todo => todo.type === TodoType.project
    );

    return ret;
};
export const getTimelineTodoList = (todos) => {
    const ret = [];
    visitTreeList(
        todos,
        todo => ret.push(todo),
        todo => {
            let parent;
            if (todo.parent) {
                parent = findBy$IdInTreeList(todos, todo.parent.$ref);
            }
            const isCandidateTask = todo.type === TodoType.task && (!todo.parent || parent.type === TodoType.project);
            const isCandidateProject = todo.type === TodoType.project;
            return [isCandidateTask || isCandidateProject, false];
        },
        todo => todo.type === TodoType.project
    );
    return ret;
};

export const getTasksAndProjectsList = (todos) => {
    const ret = [];
    // Combine projects and tasks into a single array
    const combinedTodos = [...(todos.projects || []), ...(todos.tasks || [])];

    visitTreeList(
        combinedTodos,
        todo => ret.push(todo),
        todo => {
            // Include all tasks
            if (todo.type === TodoType.task) {
                return [true, false];
            }

            // Include projects only if they have a parent (exclude top-level projects)
            if (todo.type === TodoType.project && todo.parent) {
                return [true, false];
            }

            // Exclude top-level projects (projects with no parent)
            return [false, false];
        },
        todo => todo.type === TodoType.project
    );
   
    return ret;
};
